import React from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';
import { connectToStores } from 'fluxible-addons-react';
import { get } from 'lodash';
import NavigationStore from '../../../stores/NavigationStore';
import ArticleFooter from '../../ArticleFooter';
import VideoFooter from '../../VideoFooter';
import Breadcrumbs from '../../Breadcrumbs';
import Sidebar from '../../Sidebar';
import Spinner from '../../Spinner';

class ArticleTemplate extends React.Component {
  renderFooter() {
    const { url, doc: { meta: { classes = '', editUrl, contentfulId } } } = this.props;

    if (classes.search('video-page') > -1) {
      return <VideoFooter />;
    }

      return <ArticleFooter articleUrl={url} githubEditLink={editUrl} contentfulId={contentfulId} />;
  }

  contentColumnSpan() {
    const classes = get(this.props, 'doc.meta.classes');
    if (classes && classes.search('video-page') > -1) {
      return 'col-md-9';
    }

    return 'col-md-8';
  }

  render() {
    const {
      breadcrumbs,
      contentReady,
      doc,
      section,
      sidebarArticles,
      sidebarBreadcrumbs,
      renderContent,
      url
    } = this.props;

    return (
      <StickyContainer>
        <div className="js-doc-template container" style={{ marginBottom: '40px' }}>
          <div className="row">
            <div className="sidebar-container col-md-3">
              <Sidebar
                section={section}
                items={sidebarArticles}
                maxDepth={3}
                breadcrumbs={sidebarBreadcrumbs}
                url={url}
              />
            </div>
            <div className={`${this.contentColumnSpan()} docs-content-container`}>
              {!contentReady && <Spinner />}
              {contentReady &&
                <div>
                  <Breadcrumbs crumbs={breadcrumbs} />
                  <article
                    className={`docs-content ${doc.meta.classes || ''}`}
                    data-swiftype-name="body"
                    data-swiftype-type="text"
                    data-swiftype-index="true"
                  >
                    {renderContent(doc)}
                  </article>
                  {this.renderFooter()}
                </div>
              }
            </div>
          </div>
        </div>
      </StickyContainer>
    );
  }
}

/* eslint-disable react/no-unused-prop-types */
ArticleTemplate.propTypes = {
  breadcrumbs: PropTypes.array,
  contentReady: PropTypes.bool.isRequired,
  doc: PropTypes.object.isRequired,
  renderContent: PropTypes.func.isRequired,
  section: PropTypes.string,
  sidebarBreadcrumbs: PropTypes.array,
  sidebarArticles: PropTypes.array,
  url: PropTypes.string
};

export default connectToStores(ArticleTemplate, [NavigationStore], (context, props) => {
  const { doc } = props;

  const navigationStore = context.getStore(NavigationStore);

  let breadcrumbs = [];
  let sidebarArticles = [];
  let sidebarBreadcrumbs = [];
  let section;

  if (doc && doc.meta) {
    sidebarBreadcrumbs = navigationStore.getSidebarBreadcrumbs();
    sidebarArticles = navigationStore.getSidebarArticles(doc.meta.section);
    breadcrumbs = navigationStore.getBreadcrumbs();
    section = doc.meta.section;
  }

  return {
    breadcrumbs,
    doc,
    sidebarBreadcrumbs,
    sidebarArticles,
    section
  };
});
